import React from 'react';
import { useStore } from '../context/StoreContext';
import { CheckCircle2, X } from 'lucide-react';

export const Toast: React.FC = () => {
  const { toastMessage } = useStore();

  if (!toastMessage) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-bounce-short">
      <div className="bg-[#111111] text-white border border-neutral-700 px-4 py-3 rounded-sm shadow-2xl flex items-center gap-3 text-xs font-bold max-w-sm">
        <CheckCircle2 className="w-4 h-4 text-[#25D366] shrink-0" />
        <span>{toastMessage}</span>
      </div>
    </div>
  );
};
